import axios from 'axios'
import base from '../../base'
import resource from './resource'
import { REQUEST_DATA_SUCCESS } from './mutation-types'

export default {
  requestData({ commit }, payload) {
    const config = {
      method: 'post',
      url: `${resource}/publica`,
      baseURL: base,
      data: payload
    }

    return axios(config).then(({ data }) => {
      const { Result } = data
      commit(REQUEST_DATA_SUCCESS, Result)
    })
  },

  clearData({ commit }) {
    commit(REQUEST_DATA_SUCCESS, [])
  },

  downloadFile(_, payload) {
    const config = {
      method: 'post',
      url: `${resource}/publica/dados`,
      baseURL: base,
      data: payload,
      responseType: 'arraybuffer'
    }

    return axios(config)
  }
}
